import { render, staticRenderFns } from "./CommentAndPhoto.vue?vue&type=template&id=253f6406&"
import script from "./CommentAndPhoto.vue?vue&type=script&lang=ts&"
export * from "./CommentAndPhoto.vue?vue&type=script&lang=ts&"
import style0 from "./CommentAndPhoto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports